import React, { ReactNode } from 'react';

import { CardImageBackground } from './CardImageBackground';
import { CardImageExternal } from './CardImageExternal';

type TCardImageProps = {
  value: string;
  withShadow: boolean;
  children: ReactNode;
  type?: string;
};

export const CardImage = ({
  value,
  withShadow,
  children,
  type,
}: TCardImageProps) => {
  return withShadow ? (
    <CardImageBackground value={value} type={type}>
      {children}
    </CardImageBackground>
  ) : (
    <CardImageExternal value={value}>{children}</CardImageExternal>
  );
};
